export default function special(value) {
  const normal = /\W/i;
  if (!normal.test(value)) {
    return 'special';
  }

  return null;
}
